import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appItemActionsContent]',
  standalone: true,
})
export class ItemActionsContentDirective {
  readonly templateRef = inject(TemplateRef<unknown>);
}
